import { OPTION_CHAINTOOL, OPTION_CHAINTOOL_ERROR, OPTION_CHAINTOOL_HIDE_ERROR, OPTION_CHAINTOOL_START_LOADER, OPTION_CHAINTOOL_STOP_LOADER, } from "../interface/iOptionChainTool";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const optionChainTool = (state = initState, action) => {
    switch (action.type) {
        case OPTION_CHAINTOOL:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OPTION_CHAINTOOL_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case OPTION_CHAINTOOL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case OPTION_CHAINTOOL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case OPTION_CHAINTOOL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default optionChainTool;
